import React, { useState } from 'react';
import selectPayment from '../../utils/PaymentGateways/selectPayment';
import Button from './Button';
import { useNavigate } from 'react-router-dom';

type TProps = {
  image: any;
  name: string;
  func?: React.Dispatch<React.SetStateAction<boolean>>;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  amount?: string;
  redirect?: boolean;
};
const PaymentCard = ({
  image,
  name,
  setShow,
  func = () => {
    return;
  },
  redirect,
}: TProps) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleNavigate = () => {
    if (redirect) {
      navigate('/dashboard');
    }
  };
  return (
    <div
      style={{
        background: '#FFFFFF',
        border: '0.14345px solid #F8B400',
        boxShadow: '0px 11.849px 21.5175px rgba(118, 131, 150, 0.09)',
        marginTop: '25px',
      }}
      className='p-[10px] md:p-[15px] rounded-[6px]'
    >
      <div className='mb-[20px]'>
        <img src={image} className='h-[20px] md:h-[30px]' />
      </div>

      <div>
        <b>{`Pay with ${name}`}</b>
        <div className='text-[11px] md:text-[13px] font-[500]'>
          Please enter your card details and billing information on our secure checkout page.
        </div>
      </div>

      <Button
        // type='submit'
        size='sm'
        className='mt-[20px] w-[100%] font-bold text-[10px] rounded-[6px]'
        onClick={() => {
          selectPayment({ setLoading, type: name, setShow });
          func(false);
          handleNavigate();
        }}
        disabled={loading}
      >
        {loading ? 'Please wait...' : 'SELECT'}
      </Button>
    </div>
  );
};

export default PaymentCard;
